import Api from "../../config/api";
import {
  CREATE_CREDIT_NOTE,
  DELETE_CREDIT_NOTE_SOFT,
  SEARCH_CREDIT_NOTE,
  SEARCH_CREDIT_NOTE_BY_ID,
  UPDATE_CREDIT_NOTE,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getCreditNote = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_CREDIT_NOTE, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getCreditNoteById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_CREDIT_NOTE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createCreditNote = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_CREDIT_NOTE, body);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      let msg = error?.response?.data?.message.split(":");
      if (msg[2] === " creditNoteNumber_1_company_1 dup key") {
        showToast(`Credit note number already taken`, "error");
        hideLoader();
        return error;
      } else {
        showToast(`${error?.response?.data?.message}`, "error");
        hideLoader();
      }
    }
  }
};

export const updateCreditNote = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_CREDIT_NOTE}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const restoreCreditNote = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).delete(`${DELETE_CREDIT_NOTE_SOFT}`, {
      data: body,
    });
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
